export const IconCheckRing = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
      fill="white"
      stroke="white"
      strokeWidth="1.5"
    />
    <path
      d="M6.66699 10L9.16699 12.5L13.3337 7.5"
      stroke="#6FA542"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export const IconInfo = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.612 1.29175H5.38783C2.87033 1.29175 1.29199 3.07425 1.29199 5.59675V12.4034C1.29199 14.9259 2.86283 16.7084 5.38783 16.7084H12.6112C15.137 16.7084 16.7087 14.9259 16.7087 12.4034V5.59675C16.7087 3.07425 15.137 1.29175 12.612 1.29175Z"
      fill="white"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.99577 12.3333V9"
      stroke="#77B3BA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.9916 5.83683H8.99993"
      stroke="#77B3BA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const IconWarning = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.01207 15.0306H14.9979C16.3162 15.0306 17.1437 13.6056 16.4887 12.4606L10.5004 1.98979C9.84123 0.837292 8.17957 0.836458 7.51957 1.98896L1.52123 12.4598C0.866235 13.6048 1.6929 15.0306 3.01207 15.0306Z"
      fill="#fffbeb"
      stroke="#d97706"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.0026 9.17904V6.5957"
      stroke="#d97706"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.99551 11.7499H9.00384"
      stroke="#d97706"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const IconError = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.01207 15.0306H14.9979C16.3162 15.0306 17.1437 13.6056 16.4887 12.4606L10.5004 1.98979C9.84123 0.837292 8.17957 0.836458 7.51957 1.98896L1.52123 12.4598C0.866235 13.6048 1.6929 15.0306 3.01207 15.0306Z"
      fill="#fef2f2"
      stroke="#dc2626"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.0026 9.17904V6.5957"
      stroke="#dc2626"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.99551 11.7499H9.00384"
      stroke="#dc2626"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
